import { ReadonlyURLSearchParams } from 'next/navigation';
import { createContext, useContext } from 'react';

/*
  useSearchParams prevent page from being SSR
  so we create our own context to provide safe access to searchParams with useSafeSearchParams.
  useSearchParams is only used inside SearchParamsObserver which is wrapped in Suspense and 
  only rendered on client side.
  On server side, searchParams will be null.
  On client side, searchParams will be updated by SearchParamsObserver.

*/

export type SearchParamsContextProps = {
  searchParams: ReadonlyURLSearchParams | null;
  searchParamsReady?: boolean;
};

export type SearchParamsContextValue = SearchParamsContextProps & {
  setSearchParams: (params: ReadonlyURLSearchParams | null) => void;
};

export const SearchParamsContext =
  createContext<SearchParamsContextValue | null>(null);

export const useSafeSearchParams = () => {
  const context = useContext(SearchParamsContext);
  if (!context) {
    console.error(
      'useSafeSearchParams must be used within a SafeSearchParamsProvider',
      new Error().stack,
    );
    // throw new Error(
    //   'useSafeSearchParams must be used within a SafeSearchParamsProvider',
    // );
  }
  return context?.searchParams || null;
};

/**
 * Only for SearchParamsObserver
 */
export const useSafeSearchParamsExtended = () => {
  const context = useContext(SearchParamsContext);
  if (!context && typeof window !== 'undefined') {
    throw new Error(
      'useSafeSearchParams must be used within a SafeSearchParamsProvider',
    );
  }
  return context;
};
